// SSR-safe via `typeof window` guard. In jsdom (tests) and the browser,
// the guard passes and the optional-chained access is the safety net for
// partial DDC shapes (e.g. early hydration before InvData is wired).

const callSetFilterSelections = (facetId, facetLabel) => {
	window.DDC.InvData.setFilterSelections({
		filterName: facetId,
		filterValue: '',
		filterValues: [],
		filterTitleText: facetLabel || facetId,
		isChip: false,
		isSelected: false,
		isSlider: false
	});
};

export const clearFacetGroupSelections = (facetGroup) => {
	if (typeof window === 'undefined') {
		return;
	}
	if (typeof window?.DDC?.InvData?.setFilterSelections !== 'function') {
		return;
	}

	if (
		facetGroup?.isMultiFacetGroup &&
		Array.isArray(facetGroup.multiFacets)
	) {
		facetGroup.multiFacets.forEach(({ facet }) => {
			if (facet?.id) {
				callSetFilterSelections(facet.id, facet.label);
			}
		});
		return;
	}

	const { facet } = facetGroup || {};
	if (facet?.id) {
		callSetFilterSelections(facet.id, facet.label);
	}
};

export const facetGroupHasSelections = (facetGroup) => {
	if (!facetGroup) {
		return false;
	}
	if (facetGroup.isMultiFacetGroup && Array.isArray(facetGroup.multiFacets)) {
		return facetGroup.multiFacets.some(
			(sub) =>
				Array.isArray(sub?.facetSelections?.values) &&
				sub.facetSelections.values.length > 0
		);
	}
	return (
		Array.isArray(facetGroup.selectedValues) &&
		facetGroup.selectedValues.length > 0
	);
};
